export const COURSE_CAMPAIGN = '/course_campaign/'
export const COURSE_CAMPAIGN_ALL = `${COURSE_CAMPAIGN}all`
